import axios from './api';

class productApi {

  static GetProductById = (productId, code) => {
    if (code) {
      return axios.get(`product/${productId}/${code}`);
    } else {
      return axios.get(`product/${productId}`);
    }
  };

  static CreateOrder = (data) => {

    return axios.post(`order/p24`, data);
  };

  static RequestProForma = (data) => {

    return axios.post(`order/pro-forma`, data);
  };
}
export default productApi;